/* eslint-disable */
import axios from 'axios';
import { Toast, Dialog } from 'vant';
import Vue from 'vue';
import { apiNotTip, reportVideoViewHeader, apiNoGoLoginurl, goLoginUrl } from '@/assets/utils/utils';
import store from '@/store/index';

const api = axios.create({
  baseURL: '/api',
  timeout: 20000, // 超时时间
  responseType: 'json', // default
  validateStatus: status => status === 200,
  withCredentials: true,
  headers: {
    'os-language': 'zh_CN',
    'Content-Type': 'application/json',
    'os-token-id': reportVideoViewHeader(),
  },
});

const noteCode = res => {
  const url = res.config.url;
  let msg = '';
  // 短信验证码接口
  if (url.indexOf('/user/code/send') !== -1 || url.indexOf('/user/code/login') !== -1) {
    msg = '';
    switch (res.data.code) {
      case 207:
        msg = '验证码错误，请重试';
        break;
      case 208:
        msg = '您的操作太过频繁，请稍后再尝试';
        break;
      case 209:
        msg = '验证失败，请稍后再尝试';
        break;
      case 210:
        msg = '验证码过期，请重试';
        break;
      case 211:
        msg = '短信推送已达当日上限';
        break;
      default:
        break;
    }
    Dialog({ message: msg || res.data.message, width: 240, confirmButtonColor: '#999999' });
  }
};

const responseErrFun = res => {
  noteCode(res);

  // 登录信息过期或未登录
  if (res.data.code === 2 || res.data.code === 15) {
    if (apiNoGoLoginurl(res.config.url)) {
      return Promise.reject(res.data);
    }
    // 微医打开
    if (store.state.appRoute) {
      // 微医端跳转到登录页面
      goLoginUrl();
      return Promise.reject(res.data);
    }
  }

  // 微医在微信打开
  if (store.state.appRoute && res.data.code === 299) {
    if (apiNoGoLoginurl(res.config.url)) {
      return Promise.reject(res.data);
    }
    // 微信登录没有绑定手机号
    goLoginUrl();
    return Promise.reject(res.data);
  }

  let msg = res.data.message;
  if (res.data.code === 209) {
    msg = '验证失败，请稍后再尝试';
  }
  // 用户信息为空
  if (
    !window.sessionStorage.getItem('wyDbAuthtoken') &&
    !apiNoGoLoginurl(res.config.url) &&
    store.state.appRoute &&
    res.data.code !== 1
  ) {
    goLoginUrl();
  } else {
    apiNotTip(res.config.url) ? '' : Toast(msg || '网络不给力');
  }

  return Promise.reject(res.data);
};

const setHeaderUserInfo = apiconfig => {

  // 微医
  if (store.state.appRoute) {
    if (window.sessionStorage.getItem('wyDbAuthtoken')) {
      apiconfig.headers['db-authtoken'] = window.sessionStorage.getItem('wyDbAuthtoken');
    }

    if (window.sessionStorage.getItem('appid')) {
      apiconfig.headers['appid'] = window.sessionStorage.getItem('appid');
    }
  } else {
    // 微医直播
    if (window.sessionStorage.getItem('DbAuthtoken')) {
      apiconfig.headers['db-authtoken'] = window.sessionStorage.getItem('DbAuthtoken');
    }
  }

  store.state.channel ? (apiconfig.headers['channel'] = store.state.channel) : '';
};

// 请求拦截
api.interceptors.request.use(
  apiconfig => {
    setHeaderUserInfo(apiconfig);
    return apiconfig;
  },
  e => Promise.reject(e),
);

// 响应拦截
api.interceptors.response.use(
  (res = {}) => {
    try {
      if (res.data.code !== 0) {
        return responseErrFun(res);
      }
      return Promise.resolve(res.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  err => {
    Toast(err.message || '网络不给力');
    return Promise.reject(err);
  },
);
Vue.prototype.$api = api;
export default api;
